const localApiUrl = 'http://localhost:5000'

const normalizeUrl = (value) => value ? value.replace(/\/+$/, '') : ''

const isLocalHostname = (hostname) =>
  ['localhost', '127.0.0.1'].includes(hostname)

export const resolveCustomerApiUrl = ({ hostname = '', origin = '', envApiUrl = '' } = {}) => {
  if (isLocalHostname(hostname)) {
    return normalizeUrl(envApiUrl) || localApiUrl
  }

  return normalizeUrl(origin)
}

export const joinApiBase = (baseUrl) => {
  const normalized = normalizeUrl(baseUrl)
  return /\/api$/i.test(normalized) ? normalized : `${normalized}/api`
}

